import axios from 'axios'
import constants from '../../../constants'

const getCustomerTrainingsWithMetadata = async (customerNumber: string) => {
  const { data } = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/customer-trainings/metadata`)
  return data
}

export {
  getCustomerTrainingsWithMetadata
}